"use client";

import React from "react";
import { primaryColor } from "@/lib/theme";
import { LayoutGrid, ChevronDown } from "lucide-react";
import type { PackagePreset } from "@/app/encomendas/types";

interface PresetSelectProps {
  presets: PackagePreset[];
  value: string;
  onChange: (id: string) => void;
}

export default function PresetSelect({
  presets,
  value,
  onChange,
}: PresetSelectProps) {
  const [open, setOpen] = React.useState(false);
  const selected = presets.find((p) => p.id.toString() === value) ?? null;
  const borderColor = open ? primaryColor : "#E2E5E9";

  return (
    <div className="relative w-full">
      <div
        className="border-2 rounded-control bg-paper flex items-center h-14 px-3 gap-2 cursor-pointer transition-colors select-none"
        style={{ borderColor }}
        onMouseDown={(e) => {
          e.preventDefault();
          setOpen((v) => !v);
        }}
      >
        <LayoutGrid className="w-4 h-4 text-mist shrink-0" />
        <span
          className={`flex-1 text-sm truncate ${selected ? "font-semibold text-ink" : "text-mist"}`}
        >
          {selected ? selected.name : "Selecione um modelo de pacote"}
        </span>
        <ChevronDown
          className={`w-4 h-4 text-mist shrink-0 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </div>

      {open && (
        <>
          <div
            className="fixed inset-0 z-[9998]"
            onMouseDown={() => setOpen(false)}
          />
          <div className="absolute top-full left-0 right-0 z-[9999] mt-1.5 bg-paper rounded-control border border-line shadow-float max-h-[220px] overflow-y-auto">
            <div
              onMouseDown={(e) => {
                e.preventDefault();
                onChange("");
                setOpen(false);
              }}
              className="px-4 py-3 cursor-pointer border-b border-success-soft text-body text-mist hover:bg-ground transition-colors"
            >
              Nenhum modelo
            </div>
            {presets.map((preset) => (
              <div
                key={preset.id}
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange(preset.id.toString());
                  setOpen(false);
                }}
                className={`px-4 py-3 cursor-pointer border-b border-success-soft last:border-b-0 transition-colors hover:bg-ground ${value === preset.id.toString() ? "bg-ground" : ""}`}
              >
                <p className="text-body font-semibold text-ink">
                  {preset.name}
                </p>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
